<template>
  <div>
    <h1>Czy na pewno chcesz usunąć konto <span>{{ accountToDelete }}</span>?</h1>
    <p class="red">
      Operacja jest nieodwracalna - stracisz wszystkie dane
      związane z powyższym kontem (promocje, ustawienia, statystyki etc.).
    </p>
    <p>
      Aby potwierdzić swoją decyzję, w poniższe pole wpisz nazwę obecnie
      używanego profilu, który chcesz usunąć.
    </p>
    <input type="text" v-model="inputUsername">
    <button class="btn-red" :class="{'btn-grayed': inputUsername !== accountToDelete}"
      @click="deleteAccount">
      Usuń na zawsze
    </button>
  </div>
</template>

<script>
export default {
  name: 'DeleteInstagramAccountModal',
  data() {
    return {
      inputUsername: ''
    };
  },
  computed: {
    accountToDelete() {
      return this.$store.getters.profileLogin;
    }
  },
  methods: {
    deleteAccount() {
      if (this.inputUsername !== this.accountToDelete) {
        return;
      }

      this.$store.dispatch('deleteProfile');
    }
  }
};
</script>

<style scoped>

span {
  user-select: none;
  pointer-events: none;
}

.red {
  color: #e72727;
}

input {
  text-align: center;
}

</style>
